import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

// Leaflet CSS + fix for Vite bundling (marker icons)
import "leaflet/dist/leaflet.css";
import fixLeafletIcons from "./lib/leafletFix";
fixLeafletIcons();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
